var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatPoetry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "#f3eafc",
    stroke: "#d8b4f8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 14 Q62 22 44 58 L40 62 L38 56 Q58 24 52 14Z",
    fill: "#e8d5f8",
    stroke: "#a060c8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 14 Q62 22 44 58 L42 50 Q58 24 52 14Z",
    fill: "#c8a0e8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24 Q42 26 40 30",
    stroke: "#a060c8",
    strokeWidth: 1,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 30 Q40 32 38 36",
    stroke: "#a060c8",
    strokeWidth: 1,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36 Q38 38 36 42",
    stroke: "#a060c8",
    strokeWidth: 1,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42 Q37 44 35 48",
    stroke: "#a060c8",
    strokeWidth: 1,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38 56 L36 64 L42 60 Z",
    fill: "#6030a0",
    stroke: "#4a2080",
    strokeWidth: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 64,
    r: 2,
    fill: "#4a2080"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 28,
    r: 2,
    fill: "#c080f0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 36,
    r: 1.5,
    fill: "#c080f0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 52,
    r: 1.5,
    fill: "#c080f0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatPoetry);
export default __webpack_public_path__ + "static/media/cat-poetry.59d6fb86e69d5cf9cc4bab49c9b1dca5.svg";
export { ForwardRef as ReactComponent };